import axios from 'axios';

function unwrap(res) {
  const body = res?.data;
  if (body && typeof body === 'object' && body.success === true) {
    return body.data ?? null;
  }
  return body ?? null;
}

const root = (apiUrl) => `${apiUrl}/api/routing`;

export async function fetchRoutingMeta(apiUrl) {
  return unwrap(await axios.get(`${root(apiUrl)}/meta`));
}

export async function fetchRoutingSummary(apiUrl) {
  return unwrap(await axios.get(`${root(apiUrl)}/summary`));
}

export async function listRoutingLeads(apiUrl, params = {}) {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== '' && v !== null && v !== undefined),
  );
  return unwrap(await axios.get(`${root(apiUrl)}/leads`, { params: clean }));
}

export async function getRoutingLead(apiUrl, leadId) {
  return unwrap(await axios.get(`${root(apiUrl)}/leads/${encodeURIComponent(leadId)}`));
}

/** body: {status, reason?, next_follow_up_date?, meeting_date?, clara_follow_up_notes?} */
export async function updateRoutingLead(apiUrl, leadId, body) {
  return unwrap(await axios.patch(`${root(apiUrl)}/leads/${encodeURIComponent(leadId)}`, body));
}

/** body: {assignee_id, city?} */
export async function reassignRoutingLead(apiUrl, leadId, body) {
  return unwrap(await axios.post(`${root(apiUrl)}/leads/${encodeURIComponent(leadId)}/reassign`, body));
}

export async function fetchRoster(apiUrl) {
  return unwrap(await axios.get(`${root(apiUrl)}/roster`));
}

export async function syncRoutingSheet(apiUrl) {
  return unwrap(await axios.post(`${root(apiUrl)}/sync`, null, { timeout: 280000 }));
}

/** The WhatsApp alert links to /routing/leads/<id>; this reads that id from the address bar. */
export function routingLeadIdFromLocation(loc = typeof window !== 'undefined' ? window.location : null) {
  if (!loc) return '';
  const match = /^\/routing\/leads\/([^/?#]+)/.exec(loc.pathname || '');
  return match ? decodeURIComponent(match[1]) : '';
}

export function setRoutingLeadUrl(leadId) {
  try {
    const path = leadId ? `/routing/leads/${encodeURIComponent(leadId)}` : '/';
    window.history.replaceState(null, '', path);
  } catch {
    /* the address bar is a convenience only */
  }
}
